import { useFetch } from "lib/useFetch";
import { useProdCopyUrl } from "components/PreferencesDialog/redesignUtils";

const jsApiUrl = (prodCopyUrl) => `/research/${prodCopyUrl}/subscription/estimate`;

export default function useFetchEmailForecast(requestBody) {
  const prodCopyUrl = useProdCopyUrl();
  const response = useFetch(jsApiUrl(prodCopyUrl), JSON.stringify(requestBody), "POST");

  return response;
}
